export const ENV_CONFIG = {
  API_ENDPOINT: 'https://ejhqus2i0i.execute-api.us-east-1.amazonaws.com/dev/track',
  LOG_LEVEL: 'DEBUG', // As per your naming convention for constants
  ENVIRONMENT_NAME: 'development',
};
